module.exports = __webpack_public_path__ + "static/Triceratops-5a83ec55b791dc37da20b83df04418d4.jpg";